import { Space, Tag, Tooltip } from 'antd'
import { useRef, useState, useEffect } from 'react'
import { PrimaryTag } from './PrimaryTag'
import './index.scss'

export const ShortenListTags: React.FC<{ data: string[]; width: number }> = ({ data, width }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState<string[]>([])
  const [remaining, setRemaining] = useState<string[]>([])

  useEffect(() => {
    const container = containerRef.current
    if (container) {
      const maxHeight = 80
      let totalHeight = 0
      let totalWidth = 0
      let visibleCount = 0

      // Initialize temporary tags for size calculation
      const tempContainer = document.createElement('div')
      tempContainer.style.position = 'absolute'
      tempContainer.style.visibility = 'hidden'
      tempContainer.style.width = `${width}px`
      tempContainer.style.display = 'flex'
      tempContainer.style.flexWrap = 'wrap'
      document.body.appendChild(tempContainer)

      data.forEach((data) => {
        const tempTag = document.createElement('div')
        tempTag.style.display = 'inline-block'
        tempTag.style.padding = '4px 8px'
        tempTag.style.border = 'none'
        tempTag.style.borderRadius = '4px'
        tempTag.style.fontWeight = '400'
        tempTag.style.lineHeight = '20px'
        tempTag.innerText = data
        tempContainer.appendChild(tempTag)

        // Update total height and width
        totalWidth += tempTag.offsetWidth + 8
        if (totalWidth > width) {
          totalHeight += tempTag.offsetHeight + 4
          totalWidth = tempTag.offsetWidth + 8
        }
        if (totalHeight <= maxHeight) {
          visibleCount++
        }
      })

      document.body.removeChild(tempContainer)

      setVisible(data.slice(0, visibleCount))
      setRemaining(data.slice(visibleCount))
    }
  }, [data, width])

  return (
    <Space ref={containerRef} size={[4, 4]} wrap style={{ maxWidth: width, minWidth: 100 }} className='shorten-wrapper'>
      {visible.map((name, index) => (
        <PrimaryTag key={index} value={name} />
      ))}
      {remaining.length > 0 && (
        <Tooltip
          placement='right'
          title={
            <div style={{maxHeight: 140, overflowY: 'auto', paddingRight: 16}}>
              {remaining.map((data, index) => (
                <div key={index}>{data}</div>
              ))}
            </div>
          }
        >
          <Tag
            style={{
              backgroundColor: 'colorBgBrandless',
              border: 'none',
              height: 28,
              padding: '4px 8px',
              borderRadius: 4,
              fontWeight: 400,
              lineHeight: '20px',
            }}
          >
            +{remaining.length}
          </Tag>
        </Tooltip>
      )}
    </Space>
  )
}
